// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* General Navbar Styles */
* {
    box-sizing: border-box; /* Ensures padding and borders are included in width/height */
}

body {
    margin: 0; /* Ensures no default margin on the body */
}
.navbar {
    position: sticky;
    top: 0;
    background-color: #f9f9f9;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
    z-index: 1000;
    width: 100%;
    padding: 1rem 0;
}

.navbar-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 1rem;
}

.logo {
    font-size: 1rem;
    font-weight: 700;
    color: #333;
    letter-spacing: 1px;
    display: inline-flex;
    align-items: center;
}

.nav-links {
    display: flex;
    gap: 2rem;
    transition: all 0.3s ease-in-out;
}

.nav-links a {
    text-decoration: none;
    color: #333;
    font-size: 1rem;
    font-weight: 600;
    position: relative;
    display: inline-block;
    padding: 0.5rem 0;
    transition: color 0.3s ease, transform 0.3s ease;
    width: fit-content;
}

/* Hover effect with underline animation */
.nav-links a::before {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    width: 0%;
    height: 2px;
    background-color: #a83232; /* Orange color */
    transition: width 0.3s ease;
}

.nav-links a:hover {
    color: #a83232; /* Hover text color */
}

.nav-links a:hover::before {
    width: 100%;
}

/* Active Link State - for current page indication */
.nav-links a.active {
    color: #a83232;
    font-weight: 700;
}

.hamburger {
    display: none;
    flex-direction: column;
    gap: 4px;
    background: none;
    border: none;
    cursor: pointer;
    justify-content: center;
    align-items: center;
    height: 24px;
    width: 30px;
}

.hamburger .bar {
    width: 100%;
    height: 3px;
    background-color: #333;
    transition: all 0.3s ease;
}

/* Hamburger open/close transformations */
.hamburger.open .bar:nth-child(1) {
    transform: rotate(45deg) translate(5px, 5px);
}

.hamburger.open .bar:nth-child(2) {
    opacity: 0;
}

.hamburger.open .bar:nth-child(3) {
    transform: rotate(-45deg) translate(5px, -5px);
}

/* Mobile Menu */
@media (max-width: 768px) {
    .hamburger {
        display: flex;
    }
}

/* Mobile Menu */
@media (max-width: 768px) {
    .nav-links {
        flex-direction: column;
        position: absolute;
        top: 100%;
        left: 0;
        width: 100%;
        background-color: #f9f9f9;
        box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
        max-height: 0;
        opacity: 0;
        overflow: hidden;
        border-top: 1px solid #eee;
        transition: all 0.3s ease-in-out;
    }

    .nav-links.active {
        max-height: 500px;
        opacity: 1;
        padding: 1rem;
    }

    .hamburger {
        display: flex;
    }

    /* Collapsible Section for Speakers */
    .speakers-dropdown {
        display: none;
        flex-direction: column;
        padding-left: 1rem;
        transition: all 0.3s ease-in-out;
    }

    .speakers-dropdown a {
        padding: 0.5rem 0;
        font-size: 0.9rem;
    }

    .nav-links .speakers.active + .speakers-dropdown {
        display: flex;
    }
}

/* Navbar visibility on scroll */
.navbar.show {
    top: 0;
    transition: top 0.3s ease-in-out;
}

.navbar.hide {
    top: -800px;
    transition: top 0.3s ease-in-out;
}

.dropdown-btn {
    background: none;
    border: none;
    color: white;
    font-size: 16px;
    cursor: pointer;
    width: 100%;
    text-align: left;
    padding: 10px;
    display: block;
}

.dropdown-content {
    display: flex;
    flex-direction: column;
    background: #b33b3b;
    @media (max-width: 768px) {
        position: relative !important;
    }
    position: fixed;
}

.dropdown-content a {
    color: white;
    padding: 8px 10px;
    text-decoration: none;
    display: block;
}

.dropdown-content a:hover {
    background: #000;
    color: #fff;
    width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/styles/Navbar.css"],"names":[],"mappings":"AAAA,0BAA0B;AAC1B;IACI,sBAAsB,EAAE,6DAA6D;AACzF;;AAEA;IACI,SAAS,EAAE,0CAA0C;AACzD;AACA;IACI,gBAAgB;IAChB,MAAM;IACN,yBAAyB;IACzB,wCAAwC;IACxC,aAAa;IACb,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,iBAAiB;IACjB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,mBAAmB;IACnB,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,gCAAgC;AACpC;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,qBAAqB;IACrB,iBAAiB;IACjB,gDAAgD;IAChD,kBAAkB;AACtB;;AAEA,0CAA0C;AAC1C;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,SAAS;IACT,WAAW;IACX,yBAAyB,EAAE,iBAAiB;IAC5C,2BAA2B;AAC/B;;AAEA;IACI,cAAc,EAAE,qBAAqB;AACzC;;AAEA;IACI,WAAW;AACf;;AAEA,oDAAoD;AACpD;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,WAAW;IACX,WAAW;IACX,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA,yCAAyC;AACzC;IACI,4CAA4C;AAChD;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,8CAA8C;AAClD;;AAEA,gBAAgB;AAChB;IACI;QACI,aAAa;IACjB;AACJ;;AAEA,gBAAgB;AAChB;IACI;QACI,sBAAsB;QACtB,kBAAkB;QAClB,SAAS;QACT,OAAO;QACP,WAAW;QACX,yBAAyB;QACzB,wCAAwC;QACxC,aAAa;QACb,UAAU;QACV,gBAAgB;QAChB,0BAA0B;QAC1B,gCAAgC;IACpC;;IAEA;QACI,iBAAiB;QACjB,UAAU;QACV,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA,qCAAqC;IACrC;QACI,aAAa;QACb,sBAAsB;QACtB,kBAAkB;QAClB,gCAAgC;IACpC;;IAEA;QACI,iBAAiB;QACjB,iBAAiB;IACrB;;IAEA;QACI,aAAa;IACjB;AACJ;;AAEA,gCAAgC;AAChC;IACI,MAAM;IACN,gCAAgC;AACpC;;AAEA;IACI,WAAW;IACX,gCAAgC;AACpC;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB;QACI,6BAA6B;IACjC;IACA,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,WAAW;AACf","sourcesContent":["/* General Navbar Styles */\n* {\n    box-sizing: border-box; /* Ensures padding and borders are included in width/height */\n}\n\nbody {\n    margin: 0; /* Ensures no default margin on the body */\n}\n.navbar {\n    position: sticky;\n    top: 0;\n    background-color: #f9f9f9;\n    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\n    z-index: 1000;\n    width: 100%;\n    padding: 1rem 0;\n}\n\n.navbar-container {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    max-width: 1200px;\n    margin: 0 auto;\n    padding: 0 1rem;\n}\n\n.logo {\n    font-size: 1rem;\n    font-weight: 700;\n    color: #333;\n    letter-spacing: 1px;\n    display: inline-flex;\n    align-items: center;\n}\n\n.nav-links {\n    display: flex;\n    gap: 2rem;\n    transition: all 0.3s ease-in-out;\n}\n\n.nav-links a {\n    text-decoration: none;\n    color: #333;\n    font-size: 1rem;\n    font-weight: 600;\n    position: relative;\n    display: inline-block;\n    padding: 0.5rem 0;\n    transition: color 0.3s ease, transform 0.3s ease;\n    width: fit-content;\n}\n\n/* Hover effect with underline animation */\n.nav-links a::before {\n    content: \"\";\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 0%;\n    height: 2px;\n    background-color: #a83232; /* Orange color */\n    transition: width 0.3s ease;\n}\n\n.nav-links a:hover {\n    color: #a83232; /* Hover text color */\n}\n\n.nav-links a:hover::before {\n    width: 100%;\n}\n\n/* Active Link State - for current page indication */\n.nav-links a.active {\n    color: #a83232;\n    font-weight: 700;\n}\n\n.hamburger {\n    display: none;\n    flex-direction: column;\n    gap: 4px;\n    background: none;\n    border: none;\n    cursor: pointer;\n    justify-content: center;\n    align-items: center;\n    height: 24px;\n    width: 30px;\n}\n\n.hamburger .bar {\n    width: 100%;\n    height: 3px;\n    background-color: #333;\n    transition: all 0.3s ease;\n}\n\n/* Hamburger open/close transformations */\n.hamburger.open .bar:nth-child(1) {\n    transform: rotate(45deg) translate(5px, 5px);\n}\n\n.hamburger.open .bar:nth-child(2) {\n    opacity: 0;\n}\n\n.hamburger.open .bar:nth-child(3) {\n    transform: rotate(-45deg) translate(5px, -5px);\n}\n\n/* Mobile Menu */\n@media (max-width: 768px) {\n    .hamburger {\n        display: flex;\n    }\n}\n\n/* Mobile Menu */\n@media (max-width: 768px) {\n    .nav-links {\n        flex-direction: column;\n        position: absolute;\n        top: 100%;\n        left: 0;\n        width: 100%;\n        background-color: #f9f9f9;\n        box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\n        max-height: 0;\n        opacity: 0;\n        overflow: hidden;\n        border-top: 1px solid #eee;\n        transition: all 0.3s ease-in-out;\n    }\n\n    .nav-links.active {\n        max-height: 500px;\n        opacity: 1;\n        padding: 1rem;\n    }\n\n    .hamburger {\n        display: flex;\n    }\n\n    /* Collapsible Section for Speakers */\n    .speakers-dropdown {\n        display: none;\n        flex-direction: column;\n        padding-left: 1rem;\n        transition: all 0.3s ease-in-out;\n    }\n\n    .speakers-dropdown a {\n        padding: 0.5rem 0;\n        font-size: 0.9rem;\n    }\n\n    .nav-links .speakers.active + .speakers-dropdown {\n        display: flex;\n    }\n}\n\n/* Navbar visibility on scroll */\n.navbar.show {\n    top: 0;\n    transition: top 0.3s ease-in-out;\n}\n\n.navbar.hide {\n    top: -800px;\n    transition: top 0.3s ease-in-out;\n}\n\n.dropdown-btn {\n    background: none;\n    border: none;\n    color: white;\n    font-size: 16px;\n    cursor: pointer;\n    width: 100%;\n    text-align: left;\n    padding: 10px;\n    display: block;\n}\n\n.dropdown-content {\n    display: flex;\n    flex-direction: column;\n    background: #b33b3b;\n    @media (max-width: 768px) {\n        position: relative !important;\n    }\n    position: fixed;\n}\n\n.dropdown-content a {\n    color: white;\n    padding: 8px 10px;\n    text-decoration: none;\n    display: block;\n}\n\n.dropdown-content a:hover {\n    background: #000;\n    color: #fff;\n    width: 100%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
